import { render, staticRenderFns } from "./ErrorSlotState.vue?vue&type=template&id=2cb0909e&scoped=true"
import script from "./ErrorSlotState.vue?vue&type=script&lang=js"
export * from "./ErrorSlotState.vue?vue&type=script&lang=js"
import style0 from "./ErrorSlotState.vue?vue&type=style&index=0&id=2cb0909e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0909e",
  null
  
)

export default component.exports